import type { RequestSpec } from '@/types';

export function generateJsFetch(url: string, spec: RequestSpec, hasAuth: boolean): string {
  const headers: string[] = [`'Accept': 'application/json'`];
  if (hasAuth) headers.push(`'Authorization': \`Bearer \${ACCESS_TOKEN}\``);
  if (spec.body !== undefined && spec.method !== 'GET' && spec.method !== 'DELETE') {
    headers.push(`'Content-Type': 'application/json'`);
  }

  const opts: string[] = [`method: '${spec.method}'`, `headers: {\n    ${headers.join(',\n    ')},\n  }`];
  if (spec.body !== undefined && spec.method !== 'GET' && spec.method !== 'DELETE') {
    opts.push(`body: JSON.stringify(${JSON.stringify(spec.body, null, 2)})`);
  }

  return `const ACCESS_TOKEN = 'YOUR_ACCESS_TOKEN';

const response = await fetch('${url}', {
  ${opts.join(',\n  ')},
});
const data = await response.json();
console.log(data);`;
}
